/**
 * @file AdUnitBlogSearchSidebarSlot.tsx
 *
 * @fileoverview Renders a medium rectangle ad (or similar) in the blog search
 * page sidebar.
 */

export default function AdUnitBlogSearchSidebarSlot() {
  return null;
}

export { AdUnitBlogSearchSidebarSlot };
